module.exports = __webpack_public_path__ + "img/estate-land.3101cf6d.png";